import it_IT from '../../date-picker/locale/it_IT';
export default it_IT;



// WEBPACK FOOTER //
// ./components/calendar/locale/it_IT.tsx